import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from 'tss-react/mui';
import UserAssetsContainer from '../../sources/shared/user-assets/UserAssetsContainer';
import BackgroundAssetLoadMoreCard from './BackgroundAssetLoadMoreCard';

const styles = theme => ({
    galleryProgress: {
        margin: theme.spacing(4, 0, 4, 0) 
    },
    assetsContentWrapper: {
        padding: theme.spacing(2)
    }
});

const galleryCardWidth = 145;
const galleryCardHeight = 148;

const BackgroundAssets = ({ backgroundAssets, backgroundAssetsCount }) => {
    return (<>
        <UserAssetsContainer
            userAssets={backgroundAssets}
            loadMoreButton={
                backgroundAssets.length < backgroundAssetsCount ?
                    <BackgroundAssetLoadMoreCard
                        galleryCardHeight={galleryCardHeight}
                        galleryCardWidth={galleryCardWidth}
                    /> : null
            }
        />
    </>
    );
};

const mapStateToProps = (state) => {
    const {
        backgroundAssets,
        backgroundAssetsCount
    } = state.mediaPicker;

    return { backgroundAssets, backgroundAssetsCount };
}

export default connect(mapStateToProps, {})(withStyles(BackgroundAssets, styles));